import React, { useState, useContext, useEffect, useCallback } from 'react'
import CivDataHelper from './data/CivDataHelper.js'
import MapDataHelper from './data/MapDataHelper.js'
import MatchInfo from './data/MatchInfo.js'
import DurationUtils from './utils/DurationUtils.js'
import ProfileUtils from './utils/ProfileUtils.js'

const mockServer = 'https://fadc8b46-543e-4a03-a6c5-5a33b4cbc2c5.mock.pstmn.io'
const aoe2netServer = 'https://aoe2.net'

const server = aoe2netServer

const analyzedGames = 100
const urlLastMatch = `${server}/api/player/lastmatch?game=aoe2de&profile_id=`
const urlHistory = `${server}/api/player/matches?game=aoe2de&start=0&count=${analyzedGames}&profile_id=`
const AppContext = React.createContext()

const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [loadingHistoryHost, setLoadingHistoryHost] = useState(true)
  const [loadingHistoryGuest, setLoadingHistoryGuest] = useState(true)

  const [currentMatchMap, setCurrentMatchMap] = useState()

  // Host data
  const [hostProfileId, setHostProfileId] = useState('')
  const [hostProfile, setHostProfile] = useState({})
  const [hostLastMatch, setHostLastMatch] = useState()
  const [hostCurrentMatchColor, setHostCurrentMatchColor] = useState('#faff00')
  const [hostCurrentMatchCiv, setHostCurrentMatchCiv] = useState()
  const [hostMatchesHistory, setHostMatchesHistory] = useState([])
  const [hostStatsByCiv, setHostStatsByCiv] = useState([])
  const [hostStatsByMap, setHostStatsByMap] = useState([])
  const [hostStatsByDuration, setHostStatsByDuration] = useState([])

  // Guest data
  const [guestProfileId, setGuestProfileId] = useState()
  const [guestProfile, setGuestProfile] = useState({})
  const [guestCurrentMatchColor, setGuestCurrentMatchColor] =
    useState('#faff00')
  const [guestCurrentMatchCiv, setGuestCurrentMatchCiv] = useState()
  const [guestMatchesHistory, setGuestMatchesHistory] = useState([])
  const [guestStatsByCiv, setGuestStatsByCiv] = useState([])
  const [guestStatsByMap, setGuestStatsByMap] = useState([])
  const [guestStatsByDuration, setGuestStatsByDuration] = useState([])

  // TG
  const [hostTeamMates, setHostTeamMates] = useState([
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
  ])
  const [guestTeamMates, setGuestTeamMates] = useState([
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
    {
      username: 'rudyairlines',
      profileId: 1234,
      color: '#cccccc',
      civilization: 'vikings',
      eloRM: 1205,
      eloEW: 1043,
    },
  ])

  const fetchProfile = async (profileId, saveProfile) => {
    if (profileId) {
      const profile_rm_1vs1 = await ProfileUtils.fecthProfileData(
        server,
        profileId,
        3
      )
      const profile_rm_tg = await ProfileUtils.fecthProfileData(
        server,
        profileId,
        4
      )
      const profile_unranked = await ProfileUtils.fecthProfileData(
        server,
        profileId,
        0
      )
      const profile_ew_1vs1 = await ProfileUtils.fecthProfileData(
        server,
        profileId,
        13
      )

      // Merge data and fill empties (some players don't use RM 1vs1 so they don't have an active profile)
      var profile = ProfileUtils.mergeProfileData(
        profile_rm_1vs1,
        profile_unranked
      )
      profile = ProfileUtils.mergeProfileData(profile, profile_rm_tg)
      profile = ProfileUtils.mergeProfileData(profile, profile_ew_1vs1)

      // Customize special players
      profile = ProfileUtils.customizePlayersData(profile)

      /*console.log(
        `Profile info loaded (${profileId}): ${JSON.stringify(profile)}`
      );*/

      saveProfile(profile)
    }
  }

  const refreshRival = async (profileId) => {
    let rivalId
    if (profileId) {
      console.log(`Fetching last match for player ${profileId}...`)
      try {
        const response = await fetch(`${urlLastMatch}${profileId}`)
        const data = await response.json()

        if (data) {
          let players = data.last_match.players

          var map = MapDataHelper.getMapNameById(data.last_match.map_type)
          // console.log(`map is: ${map}`)
          setCurrentMatchMap(map)

          // Get Current Match info
          setHostCurrentMatchColor(
            MatchInfo.getPlayerColors(profileId, players)
          )

          setHostCurrentMatchCiv(MatchInfo.getPlayerCiv(profileId, players))

          // Get Rival color and id
          let rival = players.filter(
            (player) => player.profile_id.toString() !== profileId
          )

          rivalId = rival[0].profile_id

          setGuestCurrentMatchColor(MatchInfo.getPlayerColors(rivalId, players))
          setGuestCurrentMatchCiv(MatchInfo.getPlayerCiv(rivalId, players))
        } else {
          console.log(`Error loading last match info ${data}`)
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      console.log(`hostProfileId is not defined`)
    }
    return rivalId
  }

  const fetchLastMatch = useCallback(async () => {
    if (hostProfileId) {
      console.log(`Fetching last match for player ${hostProfileId}`)
      setLoading(true)
      try {
        const response = await fetch(`${urlLastMatch}${hostProfileId}`)
        const data = await response.json()

        if (data) {
          setHostLastMatch(data.last_match.match_id)
          let players = data.last_match.players

          var map = MapDataHelper.getMapNameById(data.last_match.map_type)

          setCurrentMatchMap(map)

          setHostCurrentMatchColor(
            MatchInfo.getPlayerColors(hostProfileId, players)
          )

          // TG
          if (data.last_match.num_players > 2) {
            const hostTeam = MatchInfo.getPlayerTeam(hostProfileId, players)
            const hostTeamMembers = MatchInfo.getPlayerByTeam(hostTeam, players)
            setHostTeamMates(hostTeamMembers)

            const guestTeam = MatchInfo.guetOtherTeam(hostTeam, players)
            const guestTeamMembers = MatchInfo.getPlayerByTeam(
              guestTeam,
              players
            )

            setGuestTeamMates(guestTeamMembers)

            console.log(hostTeamMembers)

            // const profile_rm_1vs1 = await ProfileUtils.fecthProfileData(
            //   'https://aoe2.net',
            //   player.profile_id,
            //   3
            // )
            // const profile_ew_1vs1 = await ProfileUtils.fecthProfileData(
            //   'https://aoe2.net',
            //   player.profile_id,
            //   13
            // )
          } else {
            console.log('2 players')
          }

          players.map((player) => {
            if (player.profile_id.toString() !== hostProfileId) {
              setGuestProfileId(player.profile_id)
            }
            return player.profile_id
          })

          // Get rival
          let rival = players.filter(
            (player) => player.profile_id.toString() !== hostProfileId
          )

          var rivalId = rival[0].profile_id

          setGuestProfileId(rivalId)

          setGuestCurrentMatchColor(MatchInfo.getPlayerColors(rivalId, players))
        } else {
          console.log(`Error loading last match info ${data}`)
        }

        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }
  }, [hostProfileId])

  const fetchHistory = async (setLoadingHistory, profileId, saveHistory) => {
    if (profileId) {
      setLoadingHistory(true)

      try {
        const response = await fetch(`${urlHistory}${profileId}`)
        const data = await response.json()

        // DEBUG
        /*console.log(`Raw history data ${profileId}`);
        console.log(data);*/

        var matches = data.map((match) => {
          var ignoreMatch = false
          var match_id = match.match_id

          var { hours, minutes, seconds } =
            DurationUtils.calculateMatchDuration(
              match.finished,
              match.started,
              match.speed
            )

          // Num players
          var num_players = match.num_players

          // Map
          var map = MapDataHelper.getMapNameById(match.map_type)
          var custom_map_name = match.rms

          // Match type (RM 1v1 / RM TG / DM 1v1 / DM TG / U 1v1 / U TG / ...)
          var match_type = 'UNDEFINED'
          if (match.rating_type === 2) {
            match_type = '1v1 Random Map'
          } else if (match.rating_type === 4) {
            match_type = 'RM TG'
          } else if (match.num_players === 2 && match.rating_type === 0) {
            match_type = 'Unranked 1v1'
          } else if (match.num_players > 2 && match.rating_type === 0) {
            match_type = 'Unranked TG'
          } else if (match.rating_type === 5) {
            match_type = '1v1 Random Map Quick Play'
          } else if (match.rating_type === 6) {
            match_type = 'Team Random Map Quick Play'
          } else if (match.rating_type === 7) {
            match_type = '1v1 Empire Wars Quick Play'
          } else if (match.rating_type === 8) {
            match_type = 'Team Empire Wars Quick Play'
          } else if (match.num_players === 2 && match.rating_type === 13) {
            match_type = '1v1 Empire Wars'
          } else if (match.num_players > 2 && match.rating_type === 13) {
            match_type = 'TG Empire Wars'
          } else {
            ignoreMatch = true
          }

          var player = match.players.filter((player) => {
            if (player.profile_id == null) {
              // This is an AI
              return null
            }

            if (player.profile_id.toString() === profileId.toString()) {
              return player
            }
            return null
          })

          // Win / Loose / In progress
          var matchResult = player[0].won
          var matchDrop = player[0].drops

          // Civi
          var civilization = CivDataHelper.getCivName(player[0].civ)

          // Color
          var color = player[0].color

          if (ignoreMatch) {
            return null
          }
          return {
            match_id,
            duration: { hours, minutes, seconds },
            map,
            custom_map_name,
            match_type,
            matchResult,
            matchDrop,
            civilization,
            color,
            num_players,
          }
        })

        // Ignored matches are null, so we'll delete it
        matches = matches.filter(function (el) {
          return el != null
        })

        // DEBUG
        /*console.log(`History data parsed and cleaned up ${profileId}`);
        console.log(matches);*/

        saveHistory(matches)

        setLoadingHistory(false)
      } catch (error) {
        console.log(error)
        setLoadingHistory(false)
      }
    }
  }

  // CALCULATE STATS
  const calculateWinrateByCiv = (matches, profileId, saveStats) => {
    if (matches && matches.length > 0) {
      var result = matches.reduce((accumulator, currentValue) => {
        if (currentValue.matchResult) {
          if (accumulator[currentValue.civilization]) {
            accumulator[currentValue.civilization].wins =
              accumulator[currentValue.civilization].wins + 1
          } else {
            accumulator[currentValue.civilization] = {
              civilization: currentValue.civilization,
              wins: 1,
              looses: 0,
            }
          }
        } else {
          if (accumulator[currentValue.civilization]) {
            accumulator[currentValue.civilization].looses =
              accumulator[currentValue.civilization].looses + 1
          } else {
            accumulator[currentValue.civilization] = {
              civilization: currentValue.civilization,
              wins: 0,
              looses: 1,
            }
          }
        }

        return accumulator
      }, {})

      var toRet = Object.values(result)

      // Sort by num games
      toRet = toRet.sort((a, b) => {
        var games_a = a.wins + a.looses
        var winrate_a = a.wins / games_a
        var games_b = b.wins + b.looses
        var winrate_b = b.wins / games_b
        if (games_a > games_b) {
          return -1
        }
        if (games_a < games_b) {
          return 1
        }
        if (winrate_a > winrate_b) {
          return -1
        }

        return 1
      })

      saveStats(toRet)

      return toRet
    } else {
      return null
    }
  }

  const calculateWinrateByMap = (matches, profileId, saveStats) => {
    if (matches && matches.length > 0) {
      var result = matches.reduce((accumulator, currentValue) => {
        var mapName = MapDataHelper.getMapName(currentValue)
        if (currentValue.matchResult) {
          if (accumulator[mapName]) {
            accumulator[mapName].wins = accumulator[mapName].wins + 1
          } else {
            accumulator[mapName] = {
              map: mapName,
              wins: 1,
              looses: 0,
            }
          }
        } else {
          if (accumulator[mapName]) {
            accumulator[mapName].looses = accumulator[mapName].looses + 1
          } else {
            accumulator[mapName] = {
              map: mapName,
              wins: 0,
              looses: 1,
            }
          }
        }

        return accumulator
      }, {})

      var toRet = Object.values(result)

      // Sort by num games
      toRet = toRet.sort((a, b) => {
        var games_a = a.wins + a.looses
        var winrate_a = a.wins / games_a
        var games_b = b.wins + b.looses
        var winrate_b = b.wins / games_b
        if (games_a > games_b) {
          return -1
        }
        if (games_a < games_b) {
          return 1
        }
        if (winrate_a > winrate_b) {
          return -1
        }

        return 1
      })

      saveStats(toRet)

      return toRet
    }
  }

  const calculateWinrateByDuration = (matches, profileId, saveStats) => {
    if (matches && matches.length > 0) {
      var result = matches.reduce((accumulator, currentValue) => {
        var durationRange = DurationUtils.getDurationRange(
          currentValue.duration.hours,
          currentValue.duration.minutes,
          currentValue.duration.seconds
        )
        if (currentValue.matchResult) {
          // Win

          if (accumulator[durationRange]) {
            accumulator[durationRange].wins =
              accumulator[durationRange].wins + 1
          } else {
            accumulator[durationRange] = {
              durationRange: durationRange,
              wins: 1,
              looses: 0,
            }
          }
        } else {
          if (accumulator[durationRange]) {
            accumulator[durationRange].looses =
              accumulator[durationRange].looses + 1
          } else {
            accumulator[durationRange] = {
              durationRange: durationRange,
              wins: 0,
              looses: 1,
            }
          }
        }

        return accumulator
      }, {})

      var toRet = Object.values(result)

      // Sort by num games
      toRet = toRet.sort((a, b) => {
        if (
          DurationUtils.getDurationRageOrder(a.durationRange) >
          DurationUtils.getDurationRageOrder(b.durationRange)
        ) {
          return 1
        }
        if (
          DurationUtils.getDurationRageOrder(a.durationRange) <
          DurationUtils.getDurationRageOrder(b.durationRange)
        ) {
          return -1
        }

        return 1
      })

      saveStats(toRet)
    }
  }

  // GET ELO
  const getEloData = async (profileId) => {
    const profile_rm_1vs1 = await ProfileUtils.fecthProfileData(
      'https://aoe2.net',
      profileId,
      3
    )
    const profile_ew_1vs1 = await ProfileUtils.fecthProfileData(
      'https://aoe2.net',
      profileId,
      13
    )
    console.log(
      `Elo RM for player ${profileId} is ${JSON.stringify(profile_rm_1vs1)}`
    )
    console.log(
      `Elo EW for player ${profileId} is ${JSON.stringify(profile_ew_1vs1)}`
    )
    return {
      eloRM: profile_rm_1vs1.eloRM1vs1,
      eloEW: profile_ew_1vs1.eloEW1vs1,
    }
  }

  // LOAD LAST MATCH
  useEffect(() => {
    fetchLastMatch()
  }, [hostProfileId, fetchLastMatch])

  // LOAD PROFILES & HISTORY
  useEffect(() => {
    fetchProfile(hostProfileId, setHostProfile)
    fetchHistory(setLoadingHistoryHost, hostProfileId, setHostMatchesHistory)
  }, [hostProfileId])

  useEffect(() => {
    if (guestProfileId) {
      fetchHistory(
        setLoadingHistoryGuest,
        guestProfileId,
        setGuestMatchesHistory
      )
      fetchProfile(guestProfileId, setGuestProfile)
    }
  }, [guestProfileId])

  useEffect(() => {
    calculateWinrateByCiv(hostMatchesHistory, hostProfileId, setHostStatsByCiv)
    calculateWinrateByMap(hostMatchesHistory, hostProfileId, setHostStatsByMap)
    calculateWinrateByDuration(
      hostMatchesHistory,
      hostProfileId,
      setHostStatsByDuration
    )
  }, [hostMatchesHistory, hostProfileId])

  useEffect(() => {
    calculateWinrateByCiv(
      guestMatchesHistory,
      guestProfileId,
      setGuestStatsByCiv
    )
    calculateWinrateByMap(
      guestMatchesHistory,
      guestProfileId,
      setGuestStatsByMap
    )
    calculateWinrateByDuration(
      guestMatchesHistory,
      guestProfileId,
      setGuestStatsByDuration
    )
  }, [guestMatchesHistory, guestProfileId])

  useEffect(() => {
    const timerId = setInterval(async () => {
      let rivalId = await refreshRival(hostProfileId)
      if (guestProfileId !== rivalId) {
        console.log(`New rival: ${rivalId} (${guestProfileId})`)
        setGuestProfileId(rivalId)
      }
    }, 5000)
    return () => {
      clearTimeout(timerId)
    }
  }, [hostProfileId, guestProfileId])

  useEffect(async () => {
    console.log(
      `updating elo for host Teammates # Players: ${JSON.stringify(
        hostTeamMates
      )}`
    )
    const needUpdateElo = hostTeamMates.filter(
      (player) => player.eloRM === 0 && player.eloEW === 0
    )
    if (needUpdateElo.length > 0) {
      const newHostTeamMates = await Promise.all(
        hostTeamMates.map(async (player) => {
          const elo = await getEloData(player.profileId)

          const updatedPlayer = {
            profile_id: player.profileId,
            username: player.username,
            color: player.color,
            civilization: player.civilization,
            eloRM: elo.eloRM,
            eloEW: elo.eloEW,
          }
          console.log(
            `player: ${JSON.stringify(
              player
            )} # updatedPlayer: ${JSON.stringify(updatedPlayer)}`
          )

          return updatedPlayer
        })
      )
      setHostTeamMates(newHostTeamMates)
      console.log(
        `elo for host Teammates updated # Players: ${JSON.stringify(
          newHostTeamMates
        )}`
      )
    } else {
      console.log(`we don't need to update elo for host teammates`)
    }
  }, [hostTeamMates])

  useEffect(async () => {
    console.log(
      `updating elo for guest Teammates # Players: ${JSON.stringify(
        guestTeamMates
      )}`
    )
    const needUpdateElo = guestTeamMates.filter(
      (player) => player.eloRM === 0 && player.eloEW === 0
    )
    if (needUpdateElo.length > 0) {
      const newGuestTeamMates = await Promise.all(
        guestTeamMates.map(async (player) => {
          const elo = await getEloData(player.profileId)

          const updatedPlayer = {
            profile_id: player.profileId,
            username: player.username,
            color: player.color,
            civilization: player.civilization,
            eloRM: elo.eloRM,
            eloEW: elo.eloEW,
          }
          console.log(
            `player: ${JSON.stringify(
              player
            )} # updatedPlayer: ${JSON.stringify(updatedPlayer)}`
          )

          return updatedPlayer
        })
      )
      setGuestTeamMates(newGuestTeamMates)
      console.log(
        `elo for guest Teammates updated # Players: ${JSON.stringify(
          newGuestTeamMates
        )}`
      )
    } else {
      console.log(`we don't need to update elo for guest teammates`)
    }
  }, [guestTeamMates])

  return (
    <AppContext.Provider
      value={{
        loading,
        loadingHistoryHost,
        loadingHistoryGuest,
        currentMatchMap,
        setHostProfileId,
        hostProfileId,
        hostProfile,
        hostLastMatch,
        hostCurrentMatchColor,
        hostCurrentMatchCiv,
        hostStatsByCiv,
        hostStatsByMap,
        hostStatsByDuration,
        hostMatchesHistory,
        guestProfileId,
        guestProfile,
        guestCurrentMatchColor,
        guestCurrentMatchCiv,
        guestStatsByCiv,
        guestStatsByMap,
        guestStatsByDuration,
        hostTeamMates,
        guestTeamMates,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext)
}

export { AppContext, AppProvider }
